


// import React from "react";
// import { 
//   Card, 
//   Row, 
//   Col, 
//   Rate, 
//   Button, 
//   Tag, 
//   Typography, 
//   Divider,
//   Space,
//   Avatar,
//   Tooltip
// } from "antd";
// import {
//   PlayCircleOutlined,
//   ClockCircleOutlined,
//   BookOutlined,
//   TrophyOutlined,
//   CheckCircleOutlined,
//   StarOutlined,
//   UserOutlined,
//   GlobalOutlined,
//   SafetyCertificateOutlined,
//   ThunderboltOutlined,
//   HeartOutlined,
//   ShareAltOutlined
// } from "@ant-design/icons";

// const { Title, Text, Paragraph } = Typography;

// const CourseOverview = ({ course, imageUrl, onStartLearning }) => {
  
//   // Données par défaut si non fournies
//   const courseData = {
//     title: course?.title || "Titre du cours",
//     description: course?.description || course?.short_desc || "Description du cours à venir.",
//     rating: course?.rating || 4.5,
//     lessons: course?.lessons || "N/A",
//     duration: course?.duration || "À définir",
//     level: course?.level || "Tous niveaux",
//     language: course?.language || "Français",
//     students: course?.students || 0,
//     price: course?.latest_price || course?.price || 0,
//     prerequisites: course?.requirements || course?.prerequisites || null,
//     objectives: course?.overview || course?.objectives || null,
//     instructor: course?.instructor || "Formateur Expert",
//     lastUpdated: course?.updated_at || course?.created_at || null,
//     certificate: true
//   };

//   // Formatage de la date
//   const formatDate = (dateString) => {
//     if (!dateString) return "Récemment";
//     const date = new Date(dateString);
//     return date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
//   };

//   return (
//     <div style={{ 
//       background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//       minHeight: "100vh",
//     }}>
      
//       {/* ==================== HERO SECTION ==================== */}
//       <div style={{
//         background: "linear-gradient(135deg, #1e3a5f 0%, #3b82f6 50%, #8b5cf6 100%)",
//         borderRadius: "20px",
//         padding: "40px",
//         marginBottom: "30px",
//         position: "relative",
//         overflow: "hidden"
//       }}>
//         {/* Motif décoratif */}
//         <div style={{
//           position: "absolute",
//           top: "-50px",
//           right: "-50px",
//           width: "200px",
//           height: "200px",
//           background: "rgba(255,255,255,0.1)",
//           borderRadius: "50%"
//         }} />
//         <div style={{
//           position: "absolute",
//           bottom: "-30px",
//           left: "20%",
//           width: "100px",
//           height: "100px",
//           background: "rgba(255,255,255,0.05)",
//           borderRadius: "50%"
//         }} />

//         <Row gutter={[40, 30]} align="middle">
//           {/* Image du cours */}
//           <Col xs={24} md={10} lg={8}>
//             <div style={{
//               position: "relative",
//               borderRadius: "16px",
//               overflow: "hidden",
//               boxShadow: "0 20px 40px rgba(0,0,0,0.3)"
//             }}>
//               <img
//                 src={imageUrl || "/default-image.png"}
//                 alt={courseData.title}
//                 style={{
//                   width: "100%",
//                   height: "220px",
//                   objectFit: "cover",
//                   display: "block"
//                 }}
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.src = "/default-image.png";
//                 }}
//               />
//               {/* Badge prix */}
//               <div style={{
//                 position: "absolute",
//                 top: "15px",
//                 right: "15px",
//                 background: courseData.price > 0 
//                   ? "linear-gradient(135deg, #10b981, #059669)" 
//                   : "linear-gradient(135deg, #3b82f6, #1d4ed8)",
//                 color: "white",
//                 padding: "8px 16px",
//                 borderRadius: "20px",
//                 fontWeight: "700",
//                 fontSize: "16px",
//                 boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
//               }}>
//                 {courseData.price > 0 ? `${courseData.price} USD` : "GRATUIT"}
//               </div>
//             </div>
//           </Col>

//           {/* Infos principales */}
//           <Col xs={24} md={14} lg={16}>
//             <div style={{ color: "white" }}>
//               {/* Tags */}
//               <Space wrap style={{ marginBottom: "15px" }}>
//                 <Tag color="blue" style={{ 
//                   borderRadius: "15px", 
//                   padding: "4px 12px",
//                   border: "none",
//                   fontWeight: "600"
//                 }}>
//                   {courseData.level}
//                 </Tag>
//                 <Tag color="purple" style={{ 
//                   borderRadius: "15px", 
//                   padding: "4px 12px",
//                   border: "none",
//                   fontWeight: "600"
//                 }}>
//                   <GlobalOutlined /> {courseData.language}
//                 </Tag>
//                 {courseData.certificate && (
//                   <Tag color="gold" style={{ 
//                     borderRadius: "15px", 
//                     padding: "4px 12px",
//                     border: "none",
//                     fontWeight: "600"
//                   }}>
//                     <SafetyCertificateOutlined /> Certificat
//                   </Tag>
//                 )}
//               </Space>

//               {/* Titre */}
//               <Title level={2} style={{ 
//                 color: "white", 
//                 margin: "0 0 15px 0",
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 lineHeight: "1.3",
//                 textShadow: "0 2px 10px rgba(0,0,0,0.2)"
//               }}>
//                 {courseData.title}
//               </Title>

//               {/* Rating et stats */}
//               <div style={{ 
//                 display: "flex", 
//                 alignItems: "center", 
//                 flexWrap: "wrap",
//                 gap: "20px",
//                 marginBottom: "20px"
//               }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                   <Rate 
//                     disabled 
//                     defaultValue={courseData.rating} 
//                     allowHalf
//                     style={{ fontSize: "18px" }}
//                   />
//                   <span style={{ 
//                     fontSize: "18px", 
//                     fontWeight: "700",
//                     color: "#fbbf24"
//                   }}>
//                     {courseData.rating}
//                   </span>
//                 </div>
                
//                 {courseData.students > 0 && (
//                   <div style={{ 
//                     display: "flex", 
//                     alignItems: "center", 
//                     gap: "6px",
//                     opacity: 0.9
//                   }}>
//                     <UserOutlined />
//                     <span>{courseData.students.toLocaleString()} étudiants</span>
//                   </div>
//                 )}

//                 <div style={{ 
//                   display: "flex", 
//                   alignItems: "center", 
//                   gap: "6px",
//                   opacity: 0.9
//                 }}>
//                   <ClockCircleOutlined />
//                   <span>Mis à jour {formatDate(courseData.lastUpdated)}</span>
//                 </div>
//               </div>

//               {/* Boutons d'action */}
//               <Space size="middle">
//                 <Button
//                   type="primary"
//                   size="large"
//                   icon={<PlayCircleOutlined />}
//                   onClick={onStartLearning}
//                   style={{
//                     background: "linear-gradient(135deg, #10b981, #059669)",
//                     border: "none",
//                     borderRadius: "12px",
//                     height: "50px",
//                     padding: "0 30px",
//                     fontSize: "16px",
//                     fontWeight: "700",
//                     boxShadow: "0 8px 20px rgba(16, 185, 129, 0.4)"
//                   }}
//                 >
//                   Commencer le cours
//                 </Button>
                
//                 <Tooltip title="Ajouter aux favoris">
//                   <Button
//                     size="large"
//                     icon={<HeartOutlined />}
//                     style={{
//                       background: "rgba(255,255,255,0.2)",
//                       border: "none",
//                       borderRadius: "12px",
//                       height: "50px",
//                       width: "50px",
//                       color: "white"
//                     }}
//                   />
//                 </Tooltip>
                
//                 <Tooltip title="Partager">
//                   <Button
//                     size="large"
//                     icon={<ShareAltOutlined />}
//                     style={{
//                       background: "rgba(255,255,255,0.2)",
//                       border: "none",
//                       borderRadius: "12px",
//                       height: "50px",
//                       width: "50px",
//                       color: "white"
//                     }}
//                   />
//                 </Tooltip>
//               </Space>
//             </div>
//           </Col>
//         </Row>
//       </div>

//       {/* ==================== STATS RAPIDES ==================== */}
//       <Row gutter={[20, 20]} style={{ marginBottom: "30px" }}>
//         {[
//           { 
//             icon: <BookOutlined style={{ fontSize: "28px", color: "#3b82f6" }} />,
//             label: "Leçons",
//             value: courseData.lessons,
//             bg: "linear-gradient(135deg, #eff6ff, #dbeafe)"
//           },
//           { 
//             icon: <ClockCircleOutlined style={{ fontSize: "28px", color: "#8b5cf6" }} />,
//             label: "Durée",
//             value: courseData.duration,
//             bg: "linear-gradient(135deg, #f5f3ff, #ede9fe)"
//           },
//           { 
//             icon: <TrophyOutlined style={{ fontSize: "28px", color: "#f59e0b" }} />,
//             label: "Niveau",
//             value: courseData.level,
//             bg: "linear-gradient(135deg, #fffbeb, #fef3c7)"
//           },
//           { 
//             icon: <SafetyCertificateOutlined style={{ fontSize: "28px", color: "#10b981" }} />,
//             label: "Certificat",
//             value: "Inclus",
//             bg: "linear-gradient(135deg, #ecfdf5, #d1fae5)"
//           }
//         ].map((stat, index) => (
//           <Col xs={12} sm={12} md={6} key={index}>
//             <Card
//               style={{
//                 borderRadius: "16px",
//                 border: "none",
//                 background: stat.bg,
//                 boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
//                 height: "100%"
//               }}
//               bodyStyle={{ 
//                 padding: "20px",
//                 textAlign: "center"
//               }}
//             >
//               <div style={{ marginBottom: "10px" }}>
//                 {stat.icon}
//               </div>
//               <div style={{ 
//                 fontSize: "22px", 
//                 fontWeight: "700",
//                 color: "#1e293b",
//                 marginBottom: "4px"
//               }}>
//                 {stat.value}
//               </div>
//               <div style={{ 
//                 fontSize: "14px", 
//                 color: "#64748b",
//                 fontWeight: "500"
//               }}>
//                 {stat.label}
//               </div>
//             </Card>
//           </Col>
//         ))}
//       </Row>

//       {/* ==================== CONTENU PRINCIPAL ==================== */}
//       <Row gutter={[30, 30]}>
//         {/* Colonne gauche - Description & Objectifs */}
//         <Col xs={24} lg={16}>
//           {/* Description */}
//           <Card
//             style={{
//               borderRadius: "20px",
//               border: "none",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//               marginBottom: "25px"
//             }}
//             bodyStyle={{ padding: "30px" }}
//           >
//             <div style={{ 
//               display: "flex", 
//               alignItems: "center", 
//               gap: "12px",
//               marginBottom: "20px"
//             }}>
//               <div style={{
//                 width: "45px",
//                 height: "45px",
//                 borderRadius: "12px",
//                 background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center"
//               }}>
//                 <BookOutlined style={{ fontSize: "22px", color: "white" }} />
//               </div>
//               <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
//                 Description du cours
//               </Title>
//             </div>
            
//             <Paragraph style={{ 
//               fontSize: "16px", 
//               lineHeight: "1.8",
//               color: "#475569",
//               margin: 0
//             }}>
//               {courseData.description || "Découvrez ce cours complet qui vous permettra d'acquérir de nouvelles compétences et d'avancer dans votre carrière. Contenu de qualité préparé par des experts du domaine."}
//             </Paragraph>
//           </Card>

//           {/* Objectifs d'apprentissage */}
//           <Card
//             style={{
//               borderRadius: "20px",
//               border: "none",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//               marginBottom: "25px"
//             }}
//             bodyStyle={{ padding: "30px" }}
//           >
//             <div style={{ 
//               display: "flex", 
//               alignItems: "center", 
//               gap: "12px",
//               marginBottom: "20px"
//             }}>
//               <div style={{
//                 width: "45px",
//                 height: "45px",
//                 borderRadius: "12px",
//                 background: "linear-gradient(135deg, #10b981, #059669)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center"
//               }}>
//                 <TrophyOutlined style={{ fontSize: "22px", color: "white" }} />
//               </div>
//               <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
//                 Ce que vous apprendrez
//               </Title>
//             </div>
            
//             {courseData.objectives ? (
//               <div style={{ 
//                 fontSize: "15px", 
//                 lineHeight: "1.8",
//                 color: "#475569"
//               }}>
//                 {courseData.objectives.split('\n').map((item, index) => (
//                   item.trim() && (
//                     <div key={index} style={{ 
//                       display: "flex", 
//                       alignItems: "flex-start",
//                       gap: "12px",
//                       marginBottom: "12px",
//                       padding: "12px 15px",
//                       background: "#f0fdf4",
//                       borderRadius: "10px"
//                     }}>
//                       <CheckCircleOutlined style={{ 
//                         color: "#10b981", 
//                         fontSize: "18px",
//                         marginTop: "2px"
//                       }} />
//                       <span>{item.trim()}</span>
//                     </div>
//                   )
//                 ))}
//               </div>
//             ) : (
//               <div style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                 gap: "12px"
//               }}>
//                 {[
//                   "Maîtriser les concepts fondamentaux",
//                   "Appliquer les connaissances en pratique",
//                   "Développer des compétences professionnelles",
//                   "Obtenir une certification reconnue"
//                 ].map((objective, index) => (
//                   <div key={index} style={{ 
//                     display: "flex", 
//                     alignItems: "center",
//                     gap: "10px",
//                     padding: "12px 15px",
//                     background: "#f0fdf4",
//                     borderRadius: "10px"
//                   }}>
//                     <CheckCircleOutlined style={{ 
//                       color: "#10b981", 
//                       fontSize: "18px"
//                     }} />
//                     <span style={{ color: "#475569" }}>{objective}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </Card>

//           {/* Prérequis */}
//           <Card
//             style={{
//               borderRadius: "20px",
//               border: "none",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
//             }}
//             bodyStyle={{ padding: "30px" }}
//           >
//             <div style={{ 
//               display: "flex", 
//               alignItems: "center", 
//               gap: "12px",
//               marginBottom: "20px"
//             }}>
//               <div style={{
//                 width: "45px",
//                 height: "45px",
//                 borderRadius: "12px",
//                 background: "linear-gradient(135deg, #f59e0b, #d97706)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center"
//               }}>
//                 <ThunderboltOutlined style={{ fontSize: "22px", color: "white" }} />
//               </div>
//               <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
//                 Prérequis
//               </Title>
//             </div>
            
//             {courseData.prerequisites ? (
//               <div style={{ 
//                 fontSize: "15px", 
//                 lineHeight: "1.8",
//                 color: "#475569"
//               }}>
//                 {courseData.prerequisites.split('\n').map((item, index) => (
//                   item.trim() && (
//                     <div key={index} style={{ 
//                       display: "flex", 
//                       alignItems: "flex-start",
//                       gap: "12px",
//                       marginBottom: "10px",
//                       padding: "10px 15px",
//                       background: "#fffbeb",
//                       borderRadius: "10px"
//                     }}>
//                       <StarOutlined style={{ 
//                         color: "#f59e0b", 
//                         fontSize: "16px",
//                         marginTop: "2px"
//                       }} />
//                       <span>{item.trim()}</span>
//                     </div>
//                   )
//                 ))}
//               </div>
//             ) : (
//               <div style={{
//                 padding: "20px",
//                 background: "#fffbeb",
//                 borderRadius: "12px",
//                 textAlign: "center"
//               }}>
//                 <Text style={{ color: "#92400e", fontSize: "15px" }}>
//                   ✨ Aucun prérequis spécifique - Ce cours est accessible à tous !
//                 </Text>
//               </div>
//             )}
//           </Card>
//         </Col>

//         {/* Colonne droite - Sidebar */}
//         <Col xs={24} lg={8}>
//           {/* Card Formateur */}
//           <Card
//             style={{
//               borderRadius: "20px",
//               border: "none",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//               marginBottom: "25px"
//             }}
//             bodyStyle={{ padding: "25px" }}
//           >
//             <div style={{ textAlign: "center", marginBottom: "20px" }}>
//               <Avatar 
//                 size={80} 
//                 icon={<UserOutlined />}
//                 style={{
//                   background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
//                   marginBottom: "15px"
//                 }}
//               />
//               <Title level={5} style={{ margin: "0 0 5px 0", color: "#1e293b" }}>
//                 {courseData.instructor}
//               </Title>
//               <Text type="secondary">Formateur certifié</Text>
//             </div>
            
//             <Divider style={{ margin: "15px 0" }} />
            
//             <div style={{ textAlign: "center" }}>
//               <Button 
//                 type="default" 
//                 block
//                 style={{
//                   borderRadius: "10px",
//                   height: "42px",
//                   borderColor: "#3b82f6",
//                   color: "#3b82f6",
//                   fontWeight: "600"
//                 }}
//               >
//                 Voir le profil
//               </Button>
//             </div>
//           </Card>

//           {/* Card CTA */}
//           <Card
//             style={{
//               borderRadius: "20px",
//               border: "none",
//               background: "linear-gradient(135deg, #1e3a5f 0%, #3b82f6 100%)",
//               boxShadow: "0 10px 30px rgba(59, 130, 246, 0.3)"
//             }}
//             bodyStyle={{ padding: "30px", textAlign: "center" }}
//           >
//             <ThunderboltOutlined style={{ 
//               fontSize: "40px", 
//               color: "#fbbf24",
//               marginBottom: "15px"
//             }} />
            
//             <Title level={4} style={{ color: "white", margin: "0 0 10px 0" }}>
//               Prêt à commencer ?
//             </Title>
            
//             <Text style={{ 
//               color: "rgba(255,255,255,0.8)", 
//               display: "block",
//               marginBottom: "20px"
//             }}>
//               Accédez immédiatement à tout le contenu du cours
//             </Text>
            
//             <Button
//               type="primary"
//               size="large"
//               block
//               icon={<PlayCircleOutlined />}
//               onClick={onStartLearning}
//               style={{
//                 background: "linear-gradient(135deg, #10b981, #059669)",
//                 border: "none",
//                 borderRadius: "12px",
//                 height: "50px",
//                 fontSize: "16px",
//                 fontWeight: "700"
//               }}
//             >
//               Accéder au cours
//             </Button>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default CourseOverview;


import React from "react";
import { 
  Card, 
  Row, 
  Col, 
  Button, 
  Tag, 
  Typography, 
  Space,
  Tooltip
} from "antd";
import {
  PlayCircleOutlined,
  ClockCircleOutlined,
  BookOutlined,
  TrophyOutlined,
  CheckCircleOutlined,
  StarOutlined,
  SafetyCertificateOutlined,
  ThunderboltOutlined,
  HeartOutlined,
  ShareAltOutlined,
  AppstoreOutlined,
  TeamOutlined,
  FileTextOutlined
} from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

/* ============================================================
   CourseOverview — Affiche UNIQUEMENT les vraies données du cours
   ============================================================ */
const CourseOverview = ({ course, imageUrl, onStartLearning }) => {

  if (!course) return null;

  /* ---------- helpers ---------- */
  const hasContent = (val) => val && val.trim && val.trim().length > 0 && val.trim() !== "<p></p>";

  const stripHtml = (html) => {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Sépare le contenu HTML en items (par <li>, <br>, ou \n)
  const splitItems = (html) => {
    if (!html) return [];
    // Essaye d'abord d'extraire les <li>
    const liMatches = html.match(/<li[^>]*>(.*?)<\/li>/gi);
    if (liMatches && liMatches.length > 0) {
      return liMatches
        .map(li => stripHtml(li).trim())
        .filter(t => t.length > 0);
    }
    // Sinon split par <br>, <p>, ou \n
    return html
      .split(/<br\s*\/?>|<\/p>|<p>|\n/)
      .map(s => stripHtml(s).trim())
      .filter(t => t.length > 0);
  };

  const price = course.latest_price || 0;

  /* ---------- stats cards (seulement si données réelles existent) ---------- */
  const stats = [
    course.lessons > 0 && {
      icon: <BookOutlined style={{ fontSize: 28, color: "#3b82f6" }} />,
      label: "Leçons",
      value: course.lessons,
      bg: "linear-gradient(135deg, #eff6ff, #dbeafe)"
    },
    hasContent(course.duration) && {
      icon: <ClockCircleOutlined style={{ fontSize: 28, color: "#8b5cf6" }} />,
      label: "Durée",
      value: course.duration,
      bg: "linear-gradient(135deg, #f5f3ff, #ede9fe)"
    },
    hasContent(course.access_time) && {
      icon: <SafetyCertificateOutlined style={{ fontSize: 28, color: "#10b981" }} />,
      label: "Accès",
      value: course.access_time,
      bg: "linear-gradient(135deg, #ecfdf5, #d1fae5)"
    },
    course.category && {
      icon: <AppstoreOutlined style={{ fontSize: 28, color: "#f59e0b" }} />,
      label: "Catégorie",
      value: course.category.libelle || course.category.name || "—",
      bg: "linear-gradient(135deg, #fffbeb, #fef3c7)"
    }
  ].filter(Boolean);

  return (
    <div style={{ 
      background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
      minHeight: "100vh",
    }}>
      
      {/* ==================== HERO SECTION ==================== */}
      <div style={{
        background: "linear-gradient(135deg, #1e3a5f 0%, #3b82f6 50%, #8b5cf6 100%)",
        borderRadius: 20,
        padding: 40,
        marginBottom: 30,
        position: "relative",
        overflow: "hidden"
      }}>
        {/* Motifs décoratifs */}
        <div style={{
          position: "absolute", top: -50, right: -50,
          width: 200, height: 200,
          background: "rgba(255,255,255,0.1)", borderRadius: "50%"
        }} />
        <div style={{
          position: "absolute", bottom: -30, left: "20%",
          width: 100, height: 100,
          background: "rgba(255,255,255,0.05)", borderRadius: "50%"
        }} />

        <Row gutter={[40, 30]} align="middle">
          {/* Image */}
          <Col xs={24} md={10} lg={8}>
            <div style={{
              position: "relative", borderRadius: 16,
              overflow: "hidden", boxShadow: "0 20px 40px rgba(0,0,0,0.3)"
            }}>
              <img
                src={imageUrl || "/default-image.png"}
                alt={course.title}
                style={{ width: "100%", height: 220, objectFit: "cover", display: "block" }}
                onError={(e) => { e.target.onerror = null; e.target.src = "/default-image.png"; }}
              />
              {/* Badge prix */}
              <div style={{
                position: "absolute", top: 15, right: 15,
                background: price > 0
                  ? "linear-gradient(135deg, #10b981, #059669)"
                  : "linear-gradient(135deg, #3b82f6, #1d4ed8)",
                color: "white", padding: "8px 16px", borderRadius: 20,
                fontWeight: 700, fontSize: 16,
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
              }}>
                {price > 0 ? `${price} USD` : "GRATUIT"}
              </div>
            </div>
          </Col>

          {/* Infos principales */}
          <Col xs={24} md={14} lg={16}>
            <div style={{ color: "white" }}>
              {/* Tags réels */}
              <Space wrap style={{ marginBottom: 15 }}>
                {course.category && (
                  <Tag color="blue" style={{ borderRadius: 15, padding: "4px 12px", border: "none", fontWeight: 600 }}>
                    <AppstoreOutlined /> {course.category.libelle || course.category.name}
                  </Tag>
                )}
                {hasContent(course.access_time) && (
                  <Tag color="purple" style={{ borderRadius: 15, padding: "4px 12px", border: "none", fontWeight: 600 }}>
                    <ClockCircleOutlined /> {course.access_time}
                  </Tag>
                )}
                {course.approved && (
                  <Tag color="green" style={{ borderRadius: 15, padding: "4px 12px", border: "none", fontWeight: 600 }}>
                    <CheckCircleOutlined /> Approuvé
                  </Tag>
                )}
              </Space>

              {/* Titre */}
              <Title level={2} style={{
                color: "white", margin: "0 0 15px 0",
                fontSize: 32, fontWeight: 700, lineHeight: 1.3,
                textShadow: "0 2px 10px rgba(0,0,0,0.2)"
              }}>
                {course.title}
              </Title>

              {/* Description courte */}
              {hasContent(course.short_desc) && (
                <Paragraph style={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: 16, lineHeight: 1.6,
                  marginBottom: 20, maxWidth: 600
                }}>
                  {stripHtml(course.short_desc).length > 200
                    ? stripHtml(course.short_desc).substring(0, 200) + "…"
                    : stripHtml(course.short_desc)
                  }
                </Paragraph>
              )}

              {/* Infos rapides sous le titre */}
              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 20, marginBottom: 20 }}>
                {course.lessons > 0 && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6, opacity: 0.9 }}>
                    <BookOutlined /> <span>{course.lessons} leçons</span>
                  </div>
                )}
                {hasContent(course.duration) && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6, opacity: 0.9 }}>
                    <ClockCircleOutlined /> <span>{course.duration}</span>
                  </div>
                )}
              </div>

              {/* Boutons */}
              <Space size="middle">
                <Button
                  type="primary" size="large"
                  icon={<PlayCircleOutlined />}
                  onClick={onStartLearning}
                  style={{
                    background: "linear-gradient(135deg, #10b981, #059669)",
                    border: "none", borderRadius: 12, height: 50,
                    padding: "0 30px", fontSize: 16, fontWeight: 700,
                    boxShadow: "0 8px 20px rgba(16, 185, 129, 0.4)"
                  }}
                >
                  Commencer le cours
                </Button>
                <Tooltip title="Ajouter aux favoris">
                  <Button size="large" icon={<HeartOutlined />} style={{
                    background: "rgba(255,255,255,0.2)", border: "none",
                    borderRadius: 12, height: 50, width: 50, color: "white"
                  }} />
                </Tooltip>
                <Tooltip title="Partager">
                  <Button size="large" icon={<ShareAltOutlined />} style={{
                    background: "rgba(255,255,255,0.2)", border: "none",
                    borderRadius: 12, height: 50, width: 50, color: "white"
                  }} />
                </Tooltip>
              </Space>
            </div>
          </Col>
        </Row>
      </div>

      {/* ==================== STATS RAPIDES ==================== */}
      {stats.length > 0 && (
        <Row gutter={[20, 20]} style={{ marginBottom: 30 }}>
          {stats.map((stat, index) => (
            <Col xs={12} sm={12} md={Math.min(6, Math.floor(24 / stats.length))} key={index}>
              <Card
                style={{
                  borderRadius: 16, border: "none", background: stat.bg,
                  boxShadow: "0 4px 15px rgba(0,0,0,0.05)", height: "100%"
                }}
                bodyStyle={{ padding: 20, textAlign: "center" }}
              >
                <div style={{ marginBottom: 10 }}>{stat.icon}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: "#1e293b", marginBottom: 4 }}>
                  {stat.value}
                </div>
                <div style={{ fontSize: 14, color: "#64748b", fontWeight: 500 }}>
                  {stat.label}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {/* ==================== CONTENU PRINCIPAL ==================== */}
      <Row gutter={[30, 30]}>
        {/* Colonne gauche */}
        <Col xs={24} lg={16}>

          {/* Description */}
          {hasContent(course.short_desc) && (
            <Card
              style={{ borderRadius: 20, border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: 25 }}
              bodyStyle={{ padding: 30 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{
                  width: 45, height: 45, borderRadius: 12,
                  background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <BookOutlined style={{ fontSize: 22, color: "white" }} />
                </div>
                <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
                  Description du cours
                </Title>
              </div>
              <div
                style={{ fontSize: 16, lineHeight: 1.8, color: "#475569" }}
                dangerouslySetInnerHTML={{ __html: course.short_desc }}
              />
            </Card>
          )}

          {/* Aperçu / Overview */}
          {hasContent(course.overview) && (
            <Card
              style={{ borderRadius: 20, border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: 25 }}
              bodyStyle={{ padding: 30 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{
                  width: 45, height: 45, borderRadius: 12,
                  background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <FileTextOutlined style={{ fontSize: 22, color: "white" }} />
                </div>
                <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
                  Aperçu du cours
                </Title>
              </div>
              <div
                style={{ fontSize: 15, lineHeight: 1.8, color: "#475569" }}
                dangerouslySetInnerHTML={{ __html: course.overview }}
              />
            </Card>
          )}

          {/* Ce que vous allez apprendre */}
          {hasContent(course.what_you_will_learn) && (
            <Card
              style={{ borderRadius: 20, border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: 25 }}
              bodyStyle={{ padding: 30 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{
                  width: 45, height: 45, borderRadius: 12,
                  background: "linear-gradient(135deg, #10b981, #059669)",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <TrophyOutlined style={{ fontSize: 22, color: "white" }} />
                </div>
                <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
                  Ce que vous apprendrez
                </Title>
              </div>

              {(() => {
                const items = splitItems(course.what_you_will_learn);
                if (items.length > 1) {
                  return (
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: 12
                    }}>
                      {items.map((item, i) => (
                        <div key={i} style={{
                          display: "flex", alignItems: "flex-start", gap: 10,
                          padding: "12px 15px", background: "#f0fdf4", borderRadius: 10
                        }}>
                          <CheckCircleOutlined style={{ color: "#10b981", fontSize: 18, marginTop: 2 }} />
                          <span style={{ color: "#475569" }}>{item}</span>
                        </div>
                      ))}
                    </div>
                  );
                }
                return (
                  <div
                    style={{ fontSize: 15, lineHeight: 1.8, color: "#475569" }}
                    dangerouslySetInnerHTML={{ __html: course.what_you_will_learn }}
                  />
                );
              })()}
            </Card>
          )}

          {/* Prérequis */}
          {hasContent(course.requirements) && (
            <Card
              style={{ borderRadius: 20, border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: 25 }}
              bodyStyle={{ padding: 30 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{
                  width: 45, height: 45, borderRadius: 12,
                  background: "linear-gradient(135deg, #f59e0b, #d97706)",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <ThunderboltOutlined style={{ fontSize: 22, color: "white" }} />
                </div>
                <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
                  Prérequis
                </Title>
              </div>

              {(() => {
                const items = splitItems(course.requirements);
                if (items.length > 1) {
                  return items.map((item, i) => (
                    <div key={i} style={{
                      display: "flex", alignItems: "flex-start", gap: 12,
                      marginBottom: 10, padding: "10px 15px",
                      background: "#fffbeb", borderRadius: 10
                    }}>
                      <StarOutlined style={{ color: "#f59e0b", fontSize: 16, marginTop: 2 }} />
                      <span style={{ color: "#475569" }}>{item}</span>
                    </div>
                  ));
                }
                return (
                  <div
                    style={{ fontSize: 15, lineHeight: 1.8, color: "#475569" }}
                    dangerouslySetInnerHTML={{ __html: course.requirements }}
                  />
                );
              })()}
            </Card>
          )}

          {/* Public cible */}
          {hasContent(course.who_is_this_course_for) && (
            <Card
              style={{ borderRadius: 20, border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: 25 }}
              bodyStyle={{ padding: 30 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{
                  width: 45, height: 45, borderRadius: 12,
                  background: "linear-gradient(135deg, #ec4899, #db2777)",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <TeamOutlined style={{ fontSize: 22, color: "white" }} />
                </div>
                <Title level={4} style={{ margin: 0, color: "#1e293b" }}>
                  À qui s'adresse ce cours ?
                </Title>
              </div>

              {(() => {
                const items = splitItems(course.who_is_this_course_for);
                if (items.length > 1) {
                  return items.map((item, i) => (
                    <div key={i} style={{
                      display: "flex", alignItems: "flex-start", gap: 12,
                      marginBottom: 10, padding: "10px 15px",
                      background: "#fdf2f8", borderRadius: 10
                    }}>
                      <CheckCircleOutlined style={{ color: "#ec4899", fontSize: 16, marginTop: 2 }} />
                      <span style={{ color: "#475569" }}>{item}</span>
                    </div>
                  ));
                }
                return (
                  <div
                    style={{ fontSize: 15, lineHeight: 1.8, color: "#475569" }}
                    dangerouslySetInnerHTML={{ __html: course.who_is_this_course_for }}
                  />
                );
              })()}
            </Card>
          )}
        </Col>

        {/* Colonne droite - CTA */}
        <Col xs={24} lg={8}>
          {/* Résumé du cours */}
          <Card
            style={{
              borderRadius: 20, border: "none",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              marginBottom: 25
            }}
            bodyStyle={{ padding: 25 }}
          >
            <Title level={5} style={{ margin: "0 0 16px 0", color: "#1e293b" }}>
              Résumé
            </Title>

            {[
              course.lessons > 0 && { label: "Leçons", value: course.lessons },
              hasContent(course.duration) && { label: "Durée", value: course.duration },
              hasContent(course.access_time) && { label: "Accès", value: course.access_time },
              course.category && { label: "Catégorie", value: course.category.libelle || course.category.name },
            ].filter(Boolean).map((item, i) => (
              <div key={i} style={{
                display: "flex", justifyContent: "space-between",
                alignItems: "center", padding: "10px 0",
                borderBottom: "1px solid #f1f5f9"
              }}>
                <Text style={{ color: "#64748b", fontSize: 14 }}>{item.label}</Text>
                <Text style={{ color: "#1e293b", fontWeight: 600, fontSize: 14 }}>{item.value}</Text>
              </div>
            ))}
          </Card>

          {/* Card CTA */}
          <Card
            style={{
              borderRadius: 20, border: "none",
              background: "linear-gradient(135deg, #1e3a5f 0%, #3b82f6 100%)",
              boxShadow: "0 10px 30px rgba(59, 130, 246, 0.3)",
              position: "sticky", top: 100
            }}
            bodyStyle={{ padding: 30, textAlign: "center" }}
          >
            <ThunderboltOutlined style={{ fontSize: 40, color: "#fbbf24", marginBottom: 15 }} />
            
            <Title level={4} style={{ color: "white", margin: "0 0 10px 0" }}>
              Prêt à commencer ?
            </Title>
            
            <Text style={{ color: "rgba(255,255,255,0.8)", display: "block", marginBottom: 20 }}>
              Accédez immédiatement à tout le contenu du cours
            </Text>
            
            <Button
              type="primary" size="large" block
              icon={<PlayCircleOutlined />}
              onClick={onStartLearning}
              style={{
                background: "linear-gradient(135deg, #10b981, #059669)",
                border: "none", borderRadius: 12, height: 50,
                fontSize: 16, fontWeight: 700
              }}
            >
              Accéder au cours
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CourseOverview;